import {
  IonButton,
  IonCard,
  IonCardHeader,
  IonCardSubtitle,
  IonCardContent,
  IonItem,
  IonInput,
  IonIcon,
  IonText,
  useIonLoading,
  useIonToast,
} from "@ionic/react";
import { personOutline, saveOutline } from "ionicons/icons";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateCurrentUsername } from "../../redux/actions/currentProfileActions";

const UpdateUsername = () => {
  const dispatch = useDispatch();
  const currentUsername = useSelector(
    (state) => state.currentProfile.data?.username,
  );

  const [newUsername, setNewUsername] = useState(currentUsername || "");
  const [presentLoading, dismissLoading] = useIonLoading();
  const [presentToast] = useIonToast();

  const handleUpdate = async () => {
    // Basic frontend check to avoid unnecessary API calls
    if (newUsername === currentUsername) {
      return presentToast({ message: "No changes made.", duration: 2000 });
    }

    await presentLoading({ message: "Updating handle..." });

    const resultAction = await dispatch(updateCurrentUsername(newUsername));

    if (updateCurrentUsername.fulfilled.match(resultAction)) {
      const { status, data } = resultAction.payload;
      await dismissLoading();

      if (status === 200) {
        presentToast({
          message: "Username updated!",
          duration: 2000,
          color: "success",
        });
      } else {
        // This displays your specific controller errors (Duplicate or Regex)
        presentToast({
          message: data.error || "Update failed",
          duration: 2000,
          color: "danger",
        });
      }
    } else {
      await dismissLoading();
      presentToast({ message: "Server error", color: "danger" });
    }
  };

  return (
    <div style={{ maxWidth: "500px", margin: "20px auto" }}>
      <IonCard color="light" style={{ padding: "10px", marginBottom: "20px" }}>
        <IonCardHeader>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <IonIcon
              icon={personOutline}
              color="primary"
              style={{ fontSize: "24px" }}
            />
            <IonCardSubtitle color="dark">Account Identity</IonCardSubtitle>
          </div>
          <h2 style={{ fontWeight: "bold", marginTop: "10px" }}>
            Update Username
          </h2>
        </IonCardHeader>

        <IonCardContent>
          <IonText color="medium">
            <p>
              Choose a unique handle. This will be your public identity on
              <strong> LoonLog</strong>.
            </p>
          </IonText>

          <div className="ion-margin-top">
            <IonItem fill="outline" mode="md" className="ion-margin-bottom">
              <IonInput
                label="New Username"
                labelPlacement="stacked"
                type="text"
                placeholder="e.g. LoonTraveler123"
                value={newUsername}
                onIonInput={(e) => setNewUsername(e.detail.value)}
              />
            </IonItem>

            <IonButton
              expand="block"
              color="primary"
              disabled={!newUsername || newUsername === currentUsername}
              onClick={handleUpdate}
            >
              <IonIcon slot="start" icon={saveOutline} />
              Save Changes
            </IonButton>
          </div>
        </IonCardContent>
      </IonCard>
    </div>
  );
};

export default UpdateUsername;
